import React from "react"
import {useTranslation} from "react-i18next"

import {GenericErrorAlert} from "../../../components/Alert.tsx"
import {Loading} from "../../../components/Loading.tsx"
import {useProspectActivitiesQuery} from "../../../queries/prospects.ts"
import {apiDateToJS} from "../../../utils/dateArithmetics.ts"
import {Activity} from "../../SellingDetails/shared/ActivityFeed/components/Activity.tsx"
import {ActivityDayTitle} from "../../SellingDetails/shared/ActivityFeed/components/ActivityDayTitle.tsx"
import {groupActivities} from "../../SellingDetails/shared/ActivityFeed/utils.ts"
import {TTabComponentProps} from "./DealDetailFlyout.tsx"

export const ActivityInfo: React.FC<TTabComponentProps> = ({prospect}) => {
  const {t} = useTranslation()

  const {data, isPending, error, refetch} = useProspectActivitiesQuery({
    prospectId: prospect?.id ?? undefined,
    iterationId: undefined,
  })
  const activities = data?.data.activities
  const groupedActivities = React.useMemo(() => {
    return groupActivities(activities)
  }, [activities])

  return (
    <div className={"grow p-6"}>
      {error ? (
        <GenericErrorAlert retry={refetch} />
      ) : isPending ? (
        <Loading />
      ) : (activities ?? []).length === 0 ? (
        <div className={"flex grow items-center justify-center text-sm"}>
          {t("Reports_Prospects_ActivityFeed_NoActivities")}
        </div>
      ) : (
        <div className={"relative flex flex-col justify-between"}>
          <div role={"list"}>
            {groupedActivities.map(({date, activities}) => (
              <div key={date} role={"group"}>
                <ActivityDayTitle date={apiDateToJS(date)} />

                <div className={"divide-y divide-cr-blue-light"}>
                  {activities.map(activity => (
                    <Activity key={activity.id} activity={activity} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
